import moment from 'moment';

const dateFormats = [
  'DD/MM/YYYY',
  'D/MM/YYYY',
  'MM/DD/YY',
  'DD/MMM/YY',
  'D/MMM/YY',
  'DD/MMM/YYYY',
  'D/MMM/YYYY',
  'DD MMM, YYYY',
  'D MMM, YYYY',
  'DD MMM YYYY',
  'D MMM YYYY',
  'DD MMM YY',
  'D MMM YY',
  'DD MMM, YY',
  'D MMM, YY',
  'YYYY MMM DD',
  'YYYY MMM D',
  'YYYY-MM-DD',
  'YYYY-MM-D',
  'YYYY-MMM-DD',
  'YYYY-MMM-D',
  'DD-MM-YY',
  'D-MM-YY',
  'DD-MM-YYYY',
  'D-MM-YYYY',
  'DD-MMM-YY',
  'D-MMM-YY',
  'DD-MMM-YYYY',
  'D-MMM-YYYY',
  'DD.MM.YYYY',
  'D.MM.YYYY',
  'MMM YYYY',
  'YYYY MMM',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  'YYYY-MM-DDTHH:mm:ssZ',
  'DD/MM/YYYY:HH:mm:ssZ',
  'YYYY/MM/DD:HH:mm:ssZ',
  'DD-MM-YYYY:HH:mm:ssZ',
  'YYYY/MM/DDTHH:mm:ss.SSSZ',
];

export const parseDate = (dateString: string) => {
  for (const format of dateFormats) {
    const date = moment(dateString, format, true);
    if (date.isValid()) {
      return date;
    }
  }
  return moment(dateString);
};
